export const formatNumber = (
  num?: number | null,
  postfix?: string,
  maximumFractionDigits?: number,
): string => {
  if (num === undefined || num === null) return '';
  return num.toLocaleString(undefined, { maximumFractionDigits }).replace(',', '.') + (postfix ? ' ' + postfix : '');
};
